import { type ComponentProps, useMemo } from 'react'
import { TouchableOpacity } from 'react-native'
import { XStack } from 'tamagui'
import RatingHome from '../icons/RatingHome'
import RatingHomeGrayscale from '../icons/RatingHomeGrayscale'
import { SurveysE2E } from '../e2e'

const RatingIcon = ({
  rating,
  value,
  onPress,
  testID,
}: {
  rating: number
  value: number
} & Pick<ComponentProps<typeof TouchableOpacity>, 'onPress' | 'testID'>) => {
  const icon = useMemo(() => {
    if (rating >= value) {
      return <RatingHome width={48} height={48} />
    }

    return <RatingHomeGrayscale width={48} height={48} />
  }, [rating, value])

  return (
    <TouchableOpacity onPress={onPress} testID={testID}>
      {icon}
    </TouchableOpacity>
  )
}

export const RatingBar = ({
  rating,
  onRatingChange,
}: {
  rating: number
  onRatingChange: (rating: number) => void
}) => (
  <XStack gap="$2" justify="center" testID={SurveysE2E.Ids.View.RatingBar}>
    <RatingIcon
      rating={rating}
      value={1}
      onPress={() => onRatingChange(1)}
      testID={SurveysE2E.Ids.Press.RatingBar(1)}
    />
    <RatingIcon
      rating={rating}
      value={2}
      onPress={() => onRatingChange(2)}
      testID={SurveysE2E.Ids.Press.RatingBar(2)}
    />
    <RatingIcon
      rating={rating}
      value={3}
      onPress={() => onRatingChange(3)}
      testID={SurveysE2E.Ids.Press.RatingBar(3)}
    />
    <RatingIcon
      rating={rating}
      value={4}
      onPress={() => onRatingChange(4)}
      testID={SurveysE2E.Ids.Press.RatingBar(4)}
    />
    <RatingIcon
      rating={rating}
      value={5}
      onPress={() => onRatingChange(5)}
      testID={SurveysE2E.Ids.Press.RatingBar(5)}
    />
  </XStack>
)
